import * as dataActions from './dataActions'
import * as userActions from './userActions'

export default { ...dataActions, ...userActions }